module.exports = __webpack_public_path__ + "static/media/hu-is-q.c4d20df5.png";